import { flow } from './flow';
import { fullScreen } from './fullScreen';
import { popover } from './popover';

export const variants = { fullScreen, popover, flow };
